import React, { useState } from 'react';
import { _T, C, CSS } from '../../shared/theme';

const TEMPLATES = [
  {
    id: 'stress_checkin',
    icon: '🧘', color: '#7B6FD0',
    nl: 'Stress Check-in', en: 'Stress Check-in',
    descNL: 'Gestructureerde intake om stressniveaus en bronnen in kaart te brengen.',
    descEN: 'Structured intake to map stress levels and sources.',
    steps: [
      { nl: 'Hoe scoor je jouw stressniveau van 1-10?', en: 'How do you rate your stress level 1-10?' },
      { nl: 'Wat zijn de 3 voornaamste stressbronnen op dit moment?', en: 'What are the 3 main stress sources right now?' },
      { nl: 'Hoe beïnvloedt stress jouw slaap, eetgewoonten en beweging?', en: 'How does stress affect your sleep, eating and movement?' },
      { nl: 'Welke copingstrategieën gebruik je nu? Werken ze?', en: 'What coping strategies do you use now? Are they working?' },
      { nl: 'Stel één kleine actie voor deze week op.', en: 'Define one small action for this week.' },
    ],
  },
  {
    id: 'goal_setting',
    icon: '🎯', color: '#D4873A',
    nl: 'SMART Doelen', en: 'SMART Goals',
    descNL: 'Begeleid de klant naar een concreet, meetbaar doel.',
    descEN: 'Guide the client toward a concrete, measurable goal.',
    steps: [
      { nl: 'Wat wil je bereiken? Beschrijf het zo concreet mogelijk.', en: 'What do you want to achieve? Describe it as concretely as possible.' },
      { nl: 'Hoe meet je succes? Wat zijn de indicatoren?', en: 'How do you measure success? What are the indicators?' },
      { nl: 'Is dit doel realistisch met jouw huidige situatie?', en: 'Is this goal realistic given your current situation?' },
      { nl: 'Wanneer wil je dit bereikt hebben? Stel een deadline.', en: 'When do you want to achieve this? Set a deadline.' },
      { nl: 'Wat zijn de eerste 3 concrete stappen?', en: 'What are the first 3 concrete steps?' },
    ],
  },
  {
    id: 'burnout_assessment',
    icon: '🔥', color: '#C05050',
    nl: 'Burn-out Screening', en: 'Burnout Assessment',
    descNL: 'Vroege signalen identificeren en herstelplan opstellen.',
    descEN: 'Identify early signals and build a recovery plan.',
    steps: [
      { nl: 'Hoe lang voel je je al uitgeput? Beschrijf de tijdlijn.', en: 'How long have you felt exhausted? Describe the timeline.' },
      { nl: 'Wat geeft je nog energie? Wat kost alleen maar energie?', en: 'What still gives you energy? What only drains it?' },
      { nl: 'Hoe is je slaapkwaliteit de afgelopen maand geweest?', en: 'How has your sleep quality been over the past month?' },
      { nl: 'Heb je last van cynisme of emotionele distantie van werk/mensen?', en: 'Do you experience cynicism or emotional distance from work/people?' },
      { nl: 'Wat zijn de 3 meest urgente veranderingen die je kunt maken?', en: 'What are the 3 most urgent changes you can make?' },
    ],
  },
  {
    id: 'precomp_mental',
    icon: '🏆', color: '#C8A84B',
    nl: 'Pre-Competitie Mental Prep', en: 'Pre-Competition Mental Prep',
    descNL: 'Mentale voorbereiding voor wedstrijd of grote prestatie.',
    descEN: 'Mental preparation for competition or major performance.',
    steps: [
      { nl: 'Hoe voel je je nu fysiek en mentaal? Schaal 1-10.', en: 'How do you feel physically and mentally right now? Scale 1-10.' },
      { nl: 'Wat is je focuspunt voor vandaag? Één kerngedachte.', en: 'What is your focus point for today? One core thought.' },
      { nl: 'Visualiseer de beste versie van jouw prestatie. Beschrijf wat je ziet.', en: 'Visualise your best performance. Describe what you see.' },
      { nl: 'Wat doe je als het tegenzit? Jouw plan B.', en: 'What do you do when things go wrong? Your plan B.' },
      { nl: 'Gebruik nu 5 minuten box breathing om te kalibreren.', en: 'Use 5 minutes of box breathing to calibrate now.' },
    ],
  },
  {
    id: 'postgame_debrief',
    icon: '📋', color: '#5B9ED0',
    nl: 'Post-Game Debrief', en: 'Post-Game Debrief',
    descNL: 'Reflectie na wedstrijd of prestatie om groei te verankeren.',
    descEN: 'Reflection after competition to anchor growth.',
    steps: [
      { nl: 'Wat ging er goed? Noem 3 sterke momenten.', en: 'What went well? Name 3 strong moments.' },
      { nl: 'Wat kon beter? Wees eerlijk maar constructief.', en: 'What could be better? Be honest but constructive.' },
      { nl: 'Wat heb je geleerd over jezelf vandaag?', en: 'What did you learn about yourself today?' },
      { nl: 'Hoe is je energieniveau nu? Wat heb je nodig voor herstel?', en: 'How is your energy level now? What do you need to recover?' },
      { nl: 'Eén actie voor de volgende training/wedstrijd.', en: 'One action for the next training/competition.' },
    ],
  },
  {
    id: 'resilience_builder',
    icon: '💪', color: '#2A9E82',
    nl: 'Veerkracht Bouwen', en: 'Resilience Builder',
    descNL: 'Versterk mentale veerkracht met bewezen technieken.',
    descEN: 'Strengthen mental resilience with proven techniques.',
    steps: [
      { nl: 'Beschrijf een recente tegenslag. Hoe heb je gereageerd?', en: 'Describe a recent setback. How did you respond?' },
      { nl: 'Wat zijn jouw sterkste copingbronnen? (mensen, routines, overtuigingen)', en: 'What are your strongest coping resources? (people, routines, beliefs)' },
      { nl: 'Hoe kan je deze tegenslag herformuleren als groeikans?', en: 'How can you reframe this setback as a growth opportunity?' },
      { nl: 'Welke dagelijkse gewoonte kan je veerkracht het meest versterken?', en: 'Which daily habit would most strengthen your resilience?' },
      { nl: 'Commit aan één gewoonte voor de komende 14 dagen.', en: 'Commit to one habit for the next 14 days.' },
    ],
  },
];

const PROTOCOLS = [
  { id: 'box_breath', icon: '🫁', nl: 'Box Ademhaling', en: 'Box Breathing', descNL: '4s in - 4s vast - 4s uit - 4s pauze × 3 rondes', descEN: '4s in - 4s hold - 4s out - 4s pause × 3 rounds', duration: 4 },
  { id: '478_breath', icon: '🌬️', nl: '4-7-8 Ademhaling', en: '4-7-8 Breathing', descNL: '4s inademen - 7s vasthouden - 8s uitademen × 4', descEN: '4s inhale - 7s hold - 8s exhale × 4', duration: 3 },
  { id: 'progressive', icon: '💆', nl: 'Progressieve Ontspanning', en: 'Progressive Relaxation', descNL: 'Systematisch alle spiergroepen aanspannen en loslaten', descEN: 'Systematically tense and release all muscle groups', duration: 15 },
  { id: 'visualization', icon: '🎬', nl: 'Visualisatie Protocol', en: 'Visualization Protocol', descNL: 'Geleide mentale repetitie van de gewenste prestatie', descEN: 'Guided mental rehearsal of desired performance', duration: 10 },
  { id: 'grounding_54321', icon: '🌍', nl: '5-4-3-2-1 Grounding', en: '5-4-3-2-1 Grounding', descNL: '5 dingen zien, 4 aanraken, 3 horen, 2 ruiken, 1 proeven', descEN: '5 things to see, 4 touch, 3 hear, 2 smell, 1 taste', duration: 5 },
  { id: 'power_pose', icon: '🦁', nl: 'Power Pose Activatie', en: 'Power Pose Activation', descNL: '2 minuten expansieve houding voor zelfvertrouwen boost', descEN: '2 minutes expansive posture for confidence boost', duration: 2 },
];

const QUESTIONNAIRES = [
  { id: 'wellbeing5', icon: '🌿', nl: 'WHO-5 Welzijnsindex', en: 'WHO-5 Wellbeing Index', items: 5 },
  { id: 'readiness', icon: '⚡', nl: 'Trainingsgreedheidsscore', en: 'Training Readiness Score', items: 8 },
  { id: 'stress_pss', icon: '🧘', nl: 'Percieved Stress Schaal (PSS-10)', en: 'Perceived Stress Scale (PSS-10)', items: 10 },
  { id: 'motivation', icon: '🎯', nl: 'Intrinsieke Motivatie Index', en: 'Intrinsic Motivation Index', items: 6 },
];

function TemplateRunModal({ template, nl, onClose }) {
  const [step, setStep]   = useState(0);
  const [notes, setNotes] = useState(Array(template.steps.length).fill(''));

  const done = step >= template.steps.length;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#0e1828', border: `1px solid ${template.color}44`, borderRadius: 20, padding: 24, width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.7)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 24 }}>{template.icon}</span>
            <div style={{ color: 'white', fontSize: 14, fontWeight: 700 }}>{nl ? template.nl : template.en}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: C.silver, fontSize: 22, cursor: 'pointer' }}>×</button>
        </div>

        {/* Progress bar */}
        <div style={{ background: '#ffffff11', borderRadius: 4, height: 4, marginBottom: 20 }}>
          <div style={{ width: `${(step / template.steps.length) * 100}%`, height: '100%', background: `linear-gradient(90deg,${template.color},${template.color}cc)`, borderRadius: 4, transition: 'width 0.3s' }} />
        </div>

        {!done ? (
          <>
            <div style={{ fontSize: 10, color: template.color, letterSpacing: 2, marginBottom: 8, fontWeight: 700 }}>
              {nl ? `STAP ${step + 1} VAN ${template.steps.length}` : `STEP ${step + 1} OF ${template.steps.length}`}
            </div>
            <div style={{ color: 'white', fontSize: 15, fontWeight: 600, lineHeight: 1.5, marginBottom: 16 }}>
              {nl ? template.steps[step].nl : template.steps[step].en}
            </div>
            <textarea
              value={notes[step]}
              onChange={e => { const n = [...notes]; n[step] = e.target.value; setNotes(n); }}
              placeholder={nl ? 'Antwoord / aantekening...' : 'Answer / note...'}
              rows={4}
              style={{ width: '100%', background: '#080e1a', border: `1px solid ${template.color}33`, borderRadius: 10, color: 'white', fontSize: 13, padding: '10px 12px', resize: 'none', boxSizing: 'border-box', fontFamily: 'inherit', outline: 'none', marginBottom: 14 }}
            />
            <div style={{ display: 'flex', gap: 8 }}>
              {step > 0 && (
                <button onClick={() => setStep(s => s - 1)}
                  style={{ flex: 1, background: 'none', border: `1px solid ${_T.cardBorderBot}`, borderRadius: 10, color: C.silver, fontSize: 13, padding: '11px', cursor: 'pointer' }}>
                  ←
                </button>
              )}
              <button onClick={() => setStep(s => s + 1)}
                style={{ flex: 2, background: `linear-gradient(135deg,${template.color},${template.color}cc)`, border: 'none', borderRadius: 10, color: 'white', fontWeight: 700, fontSize: 13, padding: '11px', cursor: 'pointer' }}>
                {step < template.steps.length - 1 ? (nl ? 'Volgende →' : 'Next →') : (nl ? 'Afronden ✓' : 'Finish ✓')}
              </button>
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 10 }}>✅</div>
            <div style={{ color: 'white', fontSize: 16, fontWeight: 700, marginBottom: 6 }}>
              {nl ? 'Template voltooid!' : 'Template complete!'}
            </div>
            <div style={{ color: C.silver, fontSize: 12, lineHeight: 1.6, marginBottom: 20 }}>
              {nl ? 'Kopieer de aantekeningen naar het notitieveld van de klant.' : 'Copy the notes to the client\'s notes field.'}
            </div>
            {notes.some(n => n.trim()) && (
              <div style={{ background: '#080e1a', borderRadius: 10, padding: 12, marginBottom: 16, textAlign: 'left' }}>
                {template.steps.map((s, i) => notes[i].trim() ? (
                  <div key={i} style={{ marginBottom: 10 }}>
                    <div style={{ color: template.color, fontSize: 10, fontWeight: 700, marginBottom: 2 }}>{nl ? s.nl : s.en}</div>
                    <div style={{ color: C.silver, fontSize: 12, lineHeight: 1.5 }}>{notes[i]}</div>
                  </div>
                ) : null)}
              </div>
            )}
            <button onClick={onClose}
              style={{ width: '100%', background: `linear-gradient(135deg,${template.color},${template.color}cc)`, border: 'none', borderRadius: 12, color: 'white', fontWeight: 700, fontSize: 14, padding: '13px', cursor: 'pointer' }}>
              {nl ? 'Sluiten' : 'Close'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default function CoachToolkitTab({ lang }) {
  const nl = lang === 'nl';
  const [activeTab, setActiveTab] = useState('templates');
  const [runTemplate, setRunTemplate] = useState(null);

  return (
    <div style={{ padding: '0 0 32px' }}>
      <style>{CSS}</style>
      <div style={{ color: C.white, fontSize: 17, fontWeight: 700, marginBottom: 4 }}>{nl ? 'Coach Toolkit' : 'Coach Toolkit'}</div>
      <div style={{ color: C.silver, fontSize: 12, marginBottom: 16 }}>{nl ? 'Templates, protocollen en vragenlijsten' : 'Templates, protocols and questionnaires'}</div>

      {/* Sub-tabs */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {[['templates', nl ? 'Sessietemplates' : 'Session Templates'], ['protocols', nl ? 'Protocollen' : 'Protocols'], ['questionnaires', nl ? 'Vragenlijsten' : 'Questionnaires']].map(([v, l]) => (
          <button key={v} onClick={() => setActiveTab(v)}
            style={{ flex: 1, padding: '8px 4px', borderRadius: 10, border: `1.5px solid ${activeTab === v ? _T.accent : _T.cardBorderBot}`, background: activeTab === v ? `${_T.accent}20` : _T.bg4, color: activeTab === v ? _T.accent : C.silver, fontSize: 11, fontWeight: activeTab === v ? 700 : 400, cursor: 'pointer' }}>
            {l}
          </button>
        ))}
      </div>

      {/* Templates */}
      {activeTab === 'templates' && TEMPLATES.map(t => (
        <div key={t.id} style={{ background: _T.bg3, border: `1px solid ${_T.cardBorderBot}`, borderRadius: 14, padding: 14, marginBottom: 10 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <div style={{ width: 42, height: 42, borderRadius: 12, background: `${t.color}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0 }}>{t.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ color: C.white, fontSize: 14, fontWeight: 700 }}>{nl ? t.nl : t.en}</div>
              <div style={{ color: C.silver, fontSize: 12, lineHeight: 1.5, marginTop: 2 }}>{nl ? t.descNL : t.descEN}</div>
              <div style={{ color: C.silver2, fontSize: 11, marginTop: 4 }}>{t.steps.length} {nl ? 'stappen' : 'steps'}</div>
            </div>
            <button onClick={() => setRunTemplate(t)}
              style={{ background: `${t.color}20`, border: `1px solid ${t.color}44`, borderRadius: 10, color: t.color, fontSize: 12, fontWeight: 700, padding: '7px 14px', cursor: 'pointer', flexShrink: 0 }}>
              {nl ? 'Starten' : 'Start'}
            </button>
          </div>
        </div>
      ))}

      {/* Protocols */}
      {activeTab === 'protocols' && PROTOCOLS.map(p => (
        <div key={p.id} style={{ background: _T.bg3, border: `1px solid ${_T.cardBorderBot}`, borderRadius: 14, padding: 14, marginBottom: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ fontSize: 28 }}>{p.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ color: C.white, fontSize: 14, fontWeight: 600 }}>{nl ? p.nl : p.en}</div>
              <div style={{ color: C.silver, fontSize: 12, marginTop: 2 }}>{nl ? p.descNL : p.descEN}</div>
              <div style={{ color: _T.accent, fontSize: 11, marginTop: 2 }}>⏱ {p.duration} {nl ? 'min' : 'min'}</div>
            </div>
            <button
              style={{ background: `${_T.accent}20`, border: `1px solid ${_T.accent}44`, borderRadius: 10, color: _T.accent, fontSize: 11, fontWeight: 700, padding: '7px 12px', cursor: 'pointer' }}>
              {nl ? 'Gebruiken' : 'Use'}
            </button>
          </div>
        </div>
      ))}

      {/* Questionnaires */}
      {activeTab === 'questionnaires' && QUESTIONNAIRES.map(q => (
        <div key={q.id} style={{ background: _T.bg3, border: `1px solid ${_T.cardBorderBot}`, borderRadius: 14, padding: 14, marginBottom: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ fontSize: 28 }}>{q.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ color: C.white, fontSize: 14, fontWeight: 600 }}>{nl ? q.nl : q.en}</div>
              <div style={{ color: C.silver, fontSize: 12, marginTop: 2 }}>{q.items} {nl ? 'vragen' : 'questions'}</div>
            </div>
            <button style={{ background: `${_T.accent}20`, border: `1px solid ${_T.accent}44`, borderRadius: 10, color: _T.accent, fontSize: 11, fontWeight: 700, padding: '7px 12px', cursor: 'pointer' }}>
              {nl ? 'Uitsturen' : 'Send'}
            </button>
          </div>
        </div>
      ))}

      {runTemplate && <TemplateRunModal template={runTemplate} nl={nl} onClose={() => setRunTemplate(null)} />}
    </div>
  );
}
